import { Group, Vector3, Geometry, LineSegments, WireframeGeometry, LineBasicMaterial, Color, BufferGeometry, BufferAttribute, Line, SphereGeometry } from 'three';
import { TWEEN } from 'three/examples/jsm/libs/tween.module.min.js';

class Flower extends Group {
    constructor(parent) {
        // Call parent Group() constructor
        super();

        //console.log(line1);

        // Init state
        this.state = {
            pstate: parent.state,
            velocity: new Vector3(0,0,0),
            powerUp: this.powerUp.bind(this),
            pos1: undefined,
            pos2: undefined,
            mat: undefined,
            pow1: undefined,
            pow2: undefined,
            pow3: undefined,
            sheild: undefined,
            cpow: -1,
            timer: 0,
        };

        const geometry = new Geometry();

        geometry.vertices.push(new Vector3(3,-1,0));
        geometry.vertices.push(new Vector3(1,1,0));
        geometry.vertices.push(new Vector3(-2,1,0));
        geometry.vertices.push(new Vector3(-2,-1,0));
        geometry.vertices.push(new Vector3(3,-1,0));

        const geometry3 = new Geometry();
        geometry3.vertices.push(new Vector3(0,-1,-1));
        geometry3.vertices.push(new Vector3(0,-1,1));

        const geometry2 = new SphereGeometry( 1, 4, 2);

        const geometry4 = new SphereGeometry( .4, 4, 2);

        const geometry5 = new SphereGeometry( 5, 8, 4);

        const material = new LineBasicMaterial( {
	          color: new Color("rgb(255, 100, 0)"),
	          linewidth: 4,
	          linecap: 'round', //ignored by WebGLRenderer
	          linejoin:  'round' //ignored by WebGLRenderer
        } );
        this.state.mat = material;

         const material2 = new LineBasicMaterial( {
	          color: new Color("rgb(255, 50, 0)"),
	          linewidth: 4,
	          linecap: 'round', //ignored by WebGLRenderer
	          linejoin:  'round' //ignored by WebGLRenderer
        } );

        this.name = "flower";
        //const geometry = new SphereGeometry( 5, 5, 5 );

        const line = new Line( geometry, material);

        const line4 = new Line( geometry, material);

        const line5 = new Line( geometry3, material);

        const line6 = new Line( geometry3, material);

        const line7 = new Line( geometry3, material);

        const line8 = new Line( geometry3, material);

        line5.position.x += 3;
        line6.position.x -= 2;
        line7.position.x += 1;
        line8.position.x -= 2;
        line7.position.y += 2;
        line8.position.y += 2;

        line.position.z -= 1;
        line4.position.z += 1;

        this.add( line );
        this.add( line4 );
        this.add( line5 );
        this.add( line6 );
        this.add( line7 );
        this.add( line8 );

        const wireframe2 = new WireframeGeometry( geometry2 );

        const line2 = new LineSegments( wireframe2 );
        line2.material = material2.clone();
        line2.position.z += 2.5;
        this.add( line2 );
        this.state.pos1 = line2;

        const wireframe3 = new WireframeGeometry( geometry2 );

        const line3 = new LineSegments( wireframe3 );
        line3.material = material2.clone();
        line3.position.z -= 2.5;
        this.add( line3 );
        this.state.pos2 = line3;

        const wireframe4 = new WireframeGeometry( geometry4 );

        const pow1 = new LineSegments( wireframe4, material2.clone() );
        pow1.position.y += 2.5;
        this.add( pow1 );
        this.state.pow1 = pow1;
        pow1.visible = false;

        const pow2 = new LineSegments( wireframe4, material2.clone() );
        pow2.position.y += 2.2;
        pow2.position.z += 1;
        this.add( pow2 );
        this.state.pow2 = pow2;
        pow2.visible = false;

        const pow3 = new LineSegments( wireframe4, material2.clone() );
        pow3.position.y += 2.2;
        pow3.position.z -= 1;
        this.add( pow3 );
        this.state.pow3 = pow3;
        pow3.visible = false;

        const wireframe5 = new WireframeGeometry( geometry5 );
        const sheild = new LineSegments( wireframe5, material2.clone() );
        sheild.material.color.r = .2;
        sheild.material.color.g = .2;
        sheild.material.color.b = 1;
        sheild.material.transparent = true;
        this.add(sheild);
        sheild.visible = false;
        this.state.sheild = sheild;

        this.position.y += 1.5;
        // Add self to parent's update list
        parent.addToUpdateList(this);
    }

    powerUp(){
        this.state.cpow = this.state.pstate.power1;
        this.state.pstate.power1 = this.state.pstate.power2;
        this.state.pstate.power2 = this.state.pstate.power3;
        this.state.pstate.power3 = -1;
        if (this.state.cpow == 3){
            this.state.mat.linewidth = 12;
            this.state.timer = 500;
            this.state.pstate.damage = 5;
        }
        if (this.state.cpow == 2){
            this.state.sheild.visible = true;
            this.state.timer = 400;
        }
        if (this.state.cpow == 1){
            this.state.timer = 2;
        }
        this.state.pow3.visible = false;
        this.state.pow1.material.color = this.state.pow2.material.color;
        this.state.pow2.material.color = this.state.pow3.material.color;
        if (this.state.pstate.power2 == -1) this.state.pow2.visible = false;
        if (this.state.pstate.power1 == -1) this.state.pow1.visible = false;
    }

    update(timeStamp) {
        var v = this.state.velocity;
        //this.position.add(v);
        var angle = Math.atan2(v.x, v.z);
        this.rotation.y = angle-1.57;
        if (this.state.timer > 0){
            this.state.timer -= 1;
            if (this.state.cpow == 2 && this.state.timer < 50){
                this.state.sheild.material.opacity -= 0.01;
            }
            if (this.state.timer <= 0){
                if (this.state.cpow == 2){
                    this.state.sheild.visible = false;
                    this.state.sheild.material.opacity = 1.0;
                }
                if (this.state.cpow == 3){
                    this.state.mat.linewidth = 4;
                    this.state.pstate.damage = 2;
                }
                this.state.cpow = -1;
            }
        }
        if (this.state.pos1.material.color.b > 0){
            this.state.pos1.material.color.b -= .02;
            this.state.pos1.material.color.g -= .02;
        }
        if (this.state.pos2.material.color.b > 0){
            this.state.pos2.material.color.b -= .02;
            this.state.pos2.material.color.g -= .02;
        }
        if (this.position.distanceToSquared(this.state.pstate.tower) < 6400){
            this.state.mat.color.g = .5;
            this.state.mat.color.b = .1;
        } else{
            this.state.mat.color.g = .3;
            this.state.mat.color.b = 0.0;
        }
    }
}


export default Flower;
